module.exports = "<app-video-player></app-video-player>"